import { tokenUtils } from "../security/securityUtils.js";
import { GROUPS } from "../routes/constants";

export function checkAuth(accessToken, refreshToken) {
  const hasValidAccess = accessToken && !tokenUtils.isTokenExpired(accessToken);
  const hasValidRefresh =
    refreshToken && !tokenUtils.isTokenExpired(refreshToken);
  return hasValidAccess || hasValidRefresh;
}

// Map backend groups/roles to frontend GROUPS constants
export const mapBackendToFrontendGroup = (backendValue) => {
  const mapping = {
    admin: GROUPS.ADMINS,
    staff: GROUPS.STAFF,
    project_manager: GROUPS.PROJECT_MANAGERS,
    finance_officer: GROUPS.FINANCE_OFFICERS,
    // Add more mappings as needed
  };
  return mapping[backendValue?.toLowerCase()] || null;
};
